import React from "react";

/*eslint-disable */

declare const window: any;
const TitleComponent: React.FC = () => {
  return (
    <h1 className="title-politicas-component">Política de Cookies</h1>
  );
};

export default TitleComponent;
